module.exports = __webpack_public_path__ + "components/weather-icon/static/nightrainshowers@2-e87b80b820cf78deab2c89554145dc75.png";